interface ISearchSQLItem {
  value: string;
  operator?: "OR" | "AND" | "AND NOT";
}

interface ISearchSQLGroup {
  key?: string;
  items: ISearchSQLItem[];
  operator?: "OR" | "AND" | "AND NOT";
}

class SQLQueries {
  static fromSQLGroupToQueryString = (
    _sqlQuery: ISearchSQLGroup[],
    single?: boolean
  ) => {
    const sqlQuery = _sqlQuery.filter((group) => group.items?.length > 0);
    const query = sqlQuery
      .map((group, index) => {
        const _group = group.items
          .map((item, itemIndex) => {
            const isNotFirst = itemIndex > 0;
            return `${isNotFirst ? ` ${item.operator ?? "OR"} ` : ""}"${item.value}"`;
          })
          .join("");

        const isNotFirst = index > 0;
        return `${isNotFirst ? ` ${group.operator ?? "AND"} ` : ""}(${_group})`.trim();
      })
      .join(" ");

    if (single) {
      return query.replace(/^\(([^)]+)\)$/, "$1");
    }
    return query;
  };
}

export { SQLQueries, type ISearchSQLItem, type ISearchSQLGroup };
